'use client';

import { useState } from 'react';

import { Card, CardContent } from '@/slw/shared/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/slw/shared/ui/accordion';

export function SellingCars() {
  const [open, setOpen] = useState(true);
  const triggerClass = 'md:pt-6 md:pb-4 py-4 text-sm md:text-base font-semibold leading-[100%] flex items-center';

  return (
    <Card className='rounded-2xl bg-[#F7F7F7] shadow-sm border-0 p-6 md:p-8'>
      <div className='flex items-center justify-between'>
        <h3 className='text-xl md:text-[2rem] leading-[100%] font-bold text-foreground'>Selling Cars</h3>
        <button
          type='button'
          className='text-sm font-normal leading-[150%] text-muted-foreground hover:text-primary transition'
          onClick={() => setOpen((v) => !v)}
        >
          {open ? 'Hide' : 'Show'}
        </button>
      </div>
      {open && (
        <CardContent className='pt-0 px-0 pb-0 min-h-[40px]'>
          <CardContent className='pt-0 px-0 pb-0'>
            <Accordion type='multiple' className='divide-y divide-[#E5E5E5]'>
              <AccordionItem value='how-do-i-list-my-car'>
                <AccordionTrigger className={triggerClass}>How do I list my car?</AccordionTrigger>
                <AccordionContent className='pl-0 text-sm leading-[150%]'>
                  Click “List Your Car” in the top navigation and follow the guided steps. You’ll choose a premium
                  listing package, upload photos, write a description, and set your price.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value='is-there-a-free-listing-option'>
                <AccordionTrigger className={triggerClass}>Is there a free listing option?</AccordionTrigger>
                <AccordionContent className='pl-0 text-sm leading-[150%]'>
                  No. Clovis Classics offers only paid listings to ensure every vehicle receives quality presentation,
                  visibility, and long-term support.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value='how-long-will-my-listing-stay-live'>
                <AccordionTrigger className={triggerClass}>How long will my listing stay live?</AccordionTrigger>
                <AccordionContent className='pl-0 text-sm leading-[150%]'>
                  Until it sells—guaranteed. Your listing will remain active with us until the vehicle is marked as sold
                  or removed by you. No expiration, no pressure.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value='do-you-take-a-commission-on-sales'>
                <AccordionTrigger className={triggerClass}>Do you take a commission on sales?</AccordionTrigger>
                <AccordionContent className='pl-0 text-sm leading-[150%]'>
                  No. You pay a one-time flat fee to list your vehicle. Everything else it up to you to negotiate with
                  your buyer. We take no commission—what you sell it for is yours to keep.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value='can-i-edit-my-listing-after-posting'>
                <AccordionTrigger className={triggerClass}>Can I edit my listing after posting?</AccordionTrigger>
                <AccordionContent className='pl-0 text-sm leading-[150%]'>
                  Yes. You can update your photos, description, or price at any time from your account dashboard.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value='can-i-list-multiple-cars-or-list-my-inventory-as-a-dealer'>
                <AccordionTrigger className={triggerClass}>
                  Can I list multiple cars or list my inventory as a dealer?
                </AccordionTrigger>
                <AccordionContent className='pl-0 text-sm leading-[150%]'>
                  Absolutely. We welcome dealers and collectors with multiple vehicles. For volume pricing and dealer
                  dashboard access, email dealers@ClovisClassics.com
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </CardContent>
        </CardContent>
      )}
    </Card>
  );
}
